<template>
  <v-dialog v-model="show"
            :width="dialogWidth"
            scrollable
            persistent
  >
    <v-sheet>
      <v-toolbar>
        <v-toolbar-title>{{ dialogTitle }}</v-toolbar-title>

        <v-spacer/>

        <v-btn icon @click="show = false">
          <v-icon large>
            $close
          </v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider/>

      <v-card-text>
        <v-sheet class="d-flex justify-center flex-column"
        >
          <v-text-field name="name"
                        label="이름"
                        outlined
                        v-model="formData.name"
          >
          </v-text-field>
          <v-text-field name="mobile_number"
                        label="휴대폰번호"
                        outlined
                        v-model="formData.mobile_number"
          >
          </v-text-field>
          <v-text-field name="pw"
                        label="비밀 번호"
                        type="password"
                        outlined
                        v-model="formData.pw"
          >
          </v-text-field>
        </v-sheet>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>

        <v-btn color="secondary" depressed @click="show = false">
          취소
        </v-btn>
        <v-btn color="primary" depressed @click="loadTemporary">
          확인
        </v-btn>
      </v-card-actions>
    </v-sheet>
  </v-dialog>
</template>

<script>
import {errorControlMixin} from '@/mixins/errorControlMixin';
export default {
  name: 'SaveloadDialog',
  components: {},
  mixins: [errorControlMixin],
  props: {
    value: {type: Boolean, default: false},
    dialogTitle: {type: String, default: '불러오기'},
    dialogWidth: {type: Number, default: 320},
    applyYn: {type: String, default: 'N'},
  },
  data: () => ({
    image: null,
    formData: {
      name: '',
      mobile_number: '',
      pw: '',
      apply_yn:null,
    },
    applicant: null,
  }),
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    this.formData.apply_yn = this.applyYn;
  },
  methods: {
    loadTemporary() {
      this.$axios.post('/apply/search',this.formData).then((response) => {
        const results = response.data.results;
        if (this.applyYn === "N") {
          this.formData = Object.entries(results).reduce((acc, [key, value]) => {
            if (value !== null) {
              acc[key] = value;
            }
            return acc;
          }, {});
          this.$emit('apply-form-data', {data:this.formData, applyYn: this.applyYn });
        }
        if (this.applyYn === "Y") {
          this.applicant = results;
          this.$emit('apply-form-data', {data:this.applicant, applyYn: this.applyYn });
        }
        this.show = false;
      }).catch((error) => {
        this.errorControl(error);
      });
    }
  },
};
</script>

<style scoped>

</style>
